// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/feather/map-pin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/feather/phone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/feather/mail.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-me {
  --contact-me-padding: var(--contact-me-padding-mobile);
  --contact-me-gap: var(--contact-me-gap-mobile);

  --icon-link-list-gap: var(--social-icons-gap);
  --icon-link-size: var(--social-icons-size);

  display: flex;
  flex-direction: column;

  padding: var(--contact-me-padding);
  gap: var(--contact-me-gap);

  color: var(--col-txt-alt);
}

.contact-me__title {
  font-family: var(--h2-font);
  font-size: var(--h2-fontsize);
  text-align: center;
  font-weight: bold;
}

.contact-me__contact-div {
  display: flex;
  gap: var(--icon-link-list-gap);
  align-items: center;
}

.contact-me__social-list {
  margin: 0 auto;
}

/* mobile, horizontal */
@media only screen and (max-height: 550px) and (orientation: landscape) {
  .contact-me {
    --contact-me-padding: var(--contact-me-padding-mobile-landscape);
  }

  .contact-me__social-list {
    margin: 0 auto;
  }
}

/* tablet or larger */

@media only screen and (min-width: 767px) and (min-height: 551px) {
  .contact-me {
    --contact-me-padding: var(--contact-me-padding-tablet);
    --contact-me-gap: var(--contact-me-gap-tablet);
  }

  .contact-me__title {
    text-align: left;
  }

  .contact-me__social-list {
    margin: 0;
  }
}

/* desktop or larger */
@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {
  .about-me {
    --contact-me-padding: var(--contact-me-padding-desktop);
    --contact-me-gap: var(--contact-me-gap-desktop);
  }
}

/*** ICONS ***/
.contact-me__contact-icon {
  -webkit-mask-size: cover;
  mask-size: cover;
  background-color: var(--col-txt-alt);
  height: var(--txt-fontsize);
  aspect-ratio: 1;
}

.contact_me__address-icon {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.contact_me__phone-icon {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.contact_me__email-icon {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/contactMe.css"],"names":[],"mappings":"AAAA;EACE,sDAAsD;EACtD,8CAA8C;;EAE9C,6CAA6C;EAC7C,0CAA0C;;EAE1C,aAAa;EACb,sBAAsB;;EAEtB,kCAAkC;EAClC,0BAA0B;;EAE1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,gEAAgE;EAClE;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,qBAAqB;;AAErB;EACE;IACE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,uDAAuD;IACvD,+CAA+C;EACjD;AACF;;AAEA,cAAc;AACd;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,2DAAwD;EACxD,mDAAgD;AAClD;;AAEA;EACE,2DAAsD;EACtD,mDAA8C;AAChD;;AAEA;EACE,2DAAqD;EACrD,mDAA6C;AAC/C","sourcesContent":[".contact-me {\r\n  --contact-me-padding: var(--contact-me-padding-mobile);\r\n  --contact-me-gap: var(--contact-me-gap-mobile);\r\n\r\n  --icon-link-list-gap: var(--social-icons-gap);\r\n  --icon-link-size: var(--social-icons-size);\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  padding: var(--contact-me-padding);\r\n  gap: var(--contact-me-gap);\r\n\r\n  color: var(--col-txt-alt);\r\n}\r\n\r\n.contact-me__title {\r\n  font-family: var(--h2-font);\r\n  font-size: var(--h2-fontsize);\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.contact-me__contact-div {\r\n  display: flex;\r\n  gap: var(--icon-link-list-gap);\r\n  align-items: center;\r\n}\r\n\r\n.contact-me__social-list {\r\n  margin: 0 auto;\r\n}\r\n\r\n/* mobile, horizontal */\r\n@media only screen and (max-height: 550px) and (orientation: landscape) {\r\n  .contact-me {\r\n    --contact-me-padding: var(--contact-me-padding-mobile-landscape);\r\n  }\r\n\r\n  .contact-me__social-list {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n/* tablet or larger */\r\n\r\n@media only screen and (min-width: 767px) and (min-height: 551px) {\r\n  .contact-me {\r\n    --contact-me-padding: var(--contact-me-padding-tablet);\r\n    --contact-me-gap: var(--contact-me-gap-tablet);\r\n  }\r\n\r\n  .contact-me__title {\r\n    text-align: left;\r\n  }\r\n\r\n  .contact-me__social-list {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n/* desktop or larger */\r\n@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {\r\n  .about-me {\r\n    --contact-me-padding: var(--contact-me-padding-desktop);\r\n    --contact-me-gap: var(--contact-me-gap-desktop);\r\n  }\r\n}\r\n\r\n/*** ICONS ***/\r\n.contact-me__contact-icon {\r\n  -webkit-mask-size: cover;\r\n  mask-size: cover;\r\n  background-color: var(--col-txt-alt);\r\n  height: var(--txt-fontsize);\r\n  aspect-ratio: 1;\r\n}\r\n\r\n.contact_me__address-icon {\r\n  -webkit-mask-image: url(\"../assets/feather/map-pin.svg\");\r\n  mask-image: url(\"../assets/feather/map-pin.svg\");\r\n}\r\n\r\n.contact_me__phone-icon {\r\n  -webkit-mask-image: url(\"../assets/feather/phone.svg\");\r\n  mask-image: url(\"../assets/feather/phone.svg\");\r\n}\r\n\r\n.contact_me__email-icon {\r\n  -webkit-mask-image: url(\"../assets/feather/mail.svg\");\r\n  mask-image: url(\"../assets/feather/mail.svg\");\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
